import React from "react";
import "./TermsAndPrivacyModal.css";
const TermsAndPrivacyModal = ({ onClose }) => {
    return (
        <div
            className="TermsAndPrivacyMainCard"
        >
            <div
                className="TermsAndPrivacyMainSubCard"
            >
                <div className="row justify-content-space-between">
                    <div className="col-md-10">
                        <h2 className="TandP-H2">
                            Terms & Conditions and Privacy Policy
                        </h2>
                    </div>
                    <div className="col-md-2 d-flex justify-content-end">
                        <button className="close-button" onClick={onClose}>×</button>
                    </div>
                </div>
                <div className="TandP-content">
                    <h4>1. Introduction</h4>
                    <p className="setTextStart">
                        By using this platform, you agree to the terms mentioned herein. This includes usage, data
                        sharing, and limitations of liability.
                    </p>
                    <h4>2. Data Collection</h4>
                    <p className="setTextStart">
                        We may collect basic personal data (name, email, phone) and property-related documents to
                        improve your service experience. Your data will never be sold to third parties.
                    </p>
                    <h4>3. Use of Information</h4>
                    <p className="setTextStart">
                        Collected data is used only for verification, communication, and improving service
                        delivery.
                    </p>
                    <h4>4. Cookies</h4>
                    <p className="setTextStart">We use cookies to maintain sessions and improve user experience.</p>
                    <h4>5. Legal</h4>
                    <p className="setTextStart">
                        All content and data shared must comply with Indian IT laws and regulations. Any misuse or
                        fraud will result in immediate termination.
                    </p>
                    <h4>6. Changes</h4>
                    <p className="setTextStart">
                        We reserve the right to modify these terms at any time. Continued use of the platform
                        means acceptance of any updated terms.
                    </p>
                </div>
            </div>
        </div>
    );
};

export default TermsAndPrivacyModal;

